/**
 * Converts an integer number representing "hundredths of a dollar" into the en-US representation
 * used for dollars, such as: 123456 => 1,234.56
 */
const formattedCentsAmount = (amountInCents: number): string => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return numberFormatter.format(amountInCents / 100);
};

export default formattedCentsAmount;
